import React from 'react';

import { QuestionMarkSvg } from '../../common/svg';

import '../../../styles/shop/print-sizes-control.scss';

const PrintSizesControl = props => {
  const sizeLabels = {
    'S': 'Small',
    'M': 'Medium',
    'L': 'Large',
    'XL': 'X-Large',
  };
  const widthKeys = {
    'S': 'Width__Small_',
    'M': 'Width__Medium_',
    'L': 'Width__Large_',
    'XL': 'Width__X_Large_',
  };
  const heightKeys = {
    'S': 'Height__Small_',
    'M': 'Height__Medium_',
    'L': 'Height__Large_',
    'XL': 'Height__X_Large_',
  };

  const selectionOptions = props.data.Sizes.map(size => {
    return {
      size: size,
      label: sizeLabels[size],
      width: props.data[widthKeys[size]],
      height: props.data[heightKeys[size]],
    };
  });

  return (
    <>
      <span className="product-view__meta-label">
        Image Size{' '}
        <button
          className="icon-link"
          onClick={() => props.showModalWithContent(
            <>
              <p className="header">
                Image Size
              </p>
              <p className="body-text">
                Size of the actual image area only, not the total paper size. For unframed prints there will be an additional 1 inch border. For framed prints there will be 2 inches of mat/mount, and the then the width of the frame around this (¾”).
              </p>
            </>
          )}
        >
          { QuestionMarkSvg }
        </button>
      </span>
      <div className="print-sizes__container">
        {(selectionOptions.map(option => (
          <button
            className={`print-sizes__option ${(option.size === props.size) ? 'selected' : ''}`}
            onClick={() => props.onChange(option.size)}
          >
            <span className="print-sizes__label">{option.label}</span>
            <span className="print-sizes__size">{Number.parseFloat(option.width).toFixed(1)} x {Number.parseFloat(option.height).toFixed(1)} in</span>
          </button>
        )))}
      </div>
    </>
  );
}

export default PrintSizesControl;